<template>
  <div class="checkout-row" :class="{'heading-only': $props.headingOnly, 'height-emphasis': $props.heightEmphasized}">
    <div class="name-col">
      <h6 class="label">
        {{ $t('checkout.colName') }}
      </h6>
      <div v-if="$slots.name">
        <slot name="name"></slot>
      </div>
    </div>
    <div class="price-col">
      <h6 class="label">{{ $t('checkout.colPrice') }}</h6>
      <div v-if="$slots.price">
        <slot name="price"></slot>
      </div>
    </div>
    <div v-if="!hideRecurringPrice" class="recurring-price-col">
      <h6 class="label">{{ $t('checkout.colRecurringPrice') }}</h6>
      <div v-if="$slots['recurring-price']">
        <slot name="recurring-price"></slot>
      </div>
      <div v-if="$slots['recurring-old-price']">
        <slot name="recurring-old-price"></slot>
      </div>
    </div>
    <div v-if="$props.hasDelete"
         class="delete-button-col">
      <button type="button" @click="emitDeleteEvent">
        <img src="/assets/images/trash-can.svg" width="16" alt="" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkout-cart-row',
  props: {
    headingOnly: Boolean,
    hasDelete: Boolean,
    heightEmphasized: Boolean,
    hideRecurringPrice: Boolean
  },
  methods: {
    emitDeleteEvent () {
      this.$emit('delete-item')
    }
  }
}
</script>

<style scoped lang="scss">
.checkout-row {
  background-color: $white;
  padding: 1.6rem 2.4rem;
  margin-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @media (map_get($breakpoints, sm)) {
    flex-wrap: nowrap;
  }

  &.heading-only {
    display: none;

    @media (map_get($breakpoints, sm)) {
      display: flex;
    }

    .label {
      margin-bottom: 0;
    }
  }

  &.height-emphasis {
    min-height: 10rem;
  }

  .name-col {
    flex-basis: 100%;
    min-width: 100%;
    margin-bottom: 2.4rem;

    @media (map_get($breakpoints, sm)) {
      flex-basis: calc(62.5% - 2.4rem);
      min-width: calc(62.5% - 2.4rem);
      margin-bottom: 0;
    }
  }

  .price-col {
    flex-basis: calc(50% - 1.2rem);
    min-width: calc(50% - 1.2rem);
    margin-bottom: auto;
    white-space: nowrap;

    @media (map_get($breakpoints, sm)) {
      flex-basis: 21.5%;
      min-width: 21.5%;
      margin-bottom: 0;
    }
  }

  .recurring-price-col {
    flex-basis: calc(50% - 1.2rem);
    min-width: calc(50% - 1.2rem);
    white-space: nowrap;

    @media (map_get($breakpoints, sm)) {
      flex-basis: 16%;
      min-width: 16%;
    }
  }

  .delete-button-col {
    flex-basis: 2.4rem;
    min-width: 2.4rem;
    padding: 1.2rem 0 1.2rem 0.8rem;
    text-align: center;
    border-left: 1px solid $grey;

    button {
      font-size: 1.6rem;
      padding: 0;
      width: 2.4rem;
      height: 2.4rem;
    }
  }

  .name-col, .price-col, .recurring-price-col {
    padding-right: 1.6rem;
  }

  .label {
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
    margin: 0 0 1.6rem;
    display: block;

    @media (map_get($breakpoints, sm)) {
      display: none
    }
  }

  &.heading-only .label {
    display: block
  }

  .for-tourist & {
    justify-content: space-between;

    .name-col, .price-col {
      flex-basis: auto;
      min-width: auto;
    }

    .price-col {
      padding-right: 0;
    }

    .product-price {
      line-height: 1;
    }
  }
}
</style>
